export const contactsData = {
    email: 'stdevaux@protonmail.com',
    phone: '+33778520715',
    address: 'Nice',

    sheetAPI: ''
}